import React, { useCallback, useEffect, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Box from '@mui/material/Box'

import TextField from '@mui/material/TextField'

import {
  ILayout_Editor,
  ILayout_Cell_Props_Video,
} from '@kaidam/fc-shared/src/types/layout'

/*

  EDITOR

*/
const useStyles = makeStyles(theme => ({
}))

const VideoEditor: ILayout_Editor<ILayout_Cell_Props_Video> = ({
  cell,
  onChange,
}) => {

  const [ editUrl, setEditUrl ] = useState('')

  const classes = useStyles()

  const {
    url,
  } = cell.data

  const onUpdateURL = useCallback(() => {
    onChange({
      url: editUrl,
    })
  }, [
    editUrl,
  ])

  useEffect(() => {
    setEditUrl(url)
  }, [
    url,
  ])

  return (
    <TextField
      variant='standard'
      fullWidth
      label="Youtube URL"
      value={ editUrl || '' }
      onChange={ (e) => setEditUrl(e.target.value) }
      onBlur={ onUpdateURL }
    />
  )
}

export default VideoEditor